import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import request from "./utils/request";
import "./styles/base.less";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$request = request;

router.afterEach((to) => {
  document.title = to.meta && to.meta.title
    ? to.meta.title
    : "易尤特集团";
});

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
